export default __webpack_public_path__ + "static/media/modely9.08b91fa5.jpg";